var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatternTitan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2160,
    height: 272,
    viewBox: "0 0 2160 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.955 136.354L74.7783 270.613H1V136.354H159.955ZM160.771 134.354H86.8213L1.82324 1.29883L160.547 1.00098L160.771 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.227 136.354L268.404 270.613H342.182V136.354H183.227ZM182.411 134.354H256.361L341.359 1.29883L182.635 1.00098L182.411 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M523.228 136.354L438.051 270.613H364.273V136.354H523.228ZM524.044 134.354H450.094L365.096 1.29883L523.82 1.00098L524.044 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M546.5 136.354L631.677 270.613H705.455V136.354H546.5ZM545.684 134.354H619.634L704.632 1.29883L545.908 1.00098L545.684 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M886.5 136.354L801.324 270.613H727.545V136.354H886.5ZM887.317 134.354H813.367L728.369 1.29883L887.092 1.00098L887.317 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M909.772 136.354L994.949 270.613H1068.73V136.354H909.772ZM908.956 134.354H982.906L1067.9 1.29883L909.181 1.00098L908.956 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1249.77 136.354L1164.6 270.613H1090.82V136.354H1249.77ZM1250.59 134.354H1176.64L1091.64 1.29883L1250.37 1.00098L1250.59 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.05 136.354L1358.22 270.613H1432V136.354H1273.05ZM1272.23 134.354H1346.18L1431.18 1.29883L1272.45 1.00098L1272.23 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.05 136.354L1527.87 270.613H1454.09V136.354H1613.05ZM1613.86 134.354H1539.91L1454.91 1.29883L1613.64 1.00098L1613.86 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1636.32 136.354L1721.5 270.613H1795.27V136.354H1636.32ZM1635.5 134.354H1709.45L1794.45 1.29883L1635.73 1.00098L1635.5 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1976.32 136.354L1891.14 270.613H1817.36V136.354H1976.32ZM1977.14 134.354H1903.19L1818.19 1.29883L1976.91 1.00098L1977.14 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1999.59 136.354L2084.77 270.613H2158.55V136.354H1999.59ZM1998.77 134.354H2072.73L2157.72 1.29883L1999 1.00098L1998.77 134.354Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternTitan);
export default __webpack_public_path__ + "static/media/pattern_titan.6850a0b22af7e4cff2e4feedb54ef18b.svg";
export { ForwardRef as ReactComponent };